/**
 * @generated SignedSource<<7ce3cd5071c9c5973d7dd03425e34d4e>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type StorefrontHome_storefrontData$data = {
  readonly edges: ReadonlyArray<{
    readonly __typename: "DealerStorefrontQueryEdge";
  } | null> | null;
  readonly " $fragmentSpreads": FragmentRefs<"StorefrontCreatorsUrls_featuredCreatorsUrls" | "StorefrontFeaturedSection_products">;
  readonly " $fragmentType": "StorefrontHome_storefrontData";
};
export type StorefrontHome_storefrontData$key = {
  readonly " $data"?: StorefrontHome_storefrontData$data;
  readonly " $fragmentSpreads": FragmentRefs<"StorefrontHome_storefrontData">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "StorefrontHome_storefrontData",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "DealerStorefrontQueryEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "__typename",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "StorefrontFeaturedSection_products"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "StorefrontCreatorsUrls_featuredCreatorsUrls"
    }
  ],
  "type": "DealerStorefrontQueryConnection",
  "abstractKey": null
};

(node as any).hash = "8b4546a147b19771bfa7fde38c94a701";

export default node;
